module.exports = __webpack_public_path__ + "img/menulingua_logo_v2_white.015837c2.svg";